import { Button, Card, Grid, Input, Modal, Table, message } from 'antd'
import fileDownload from 'js-file-download'
import React, { useState } from 'react'
import { useCreateUserLinkMutation, useGetMyContactsQuery, useLazyGetMyContactsQuery } from '../../api/userLink.api'
import { useMyContext } from '../../context/context'
import ContactDisplay from '../../components/ContactDisplay'
import useHistoryCustom from '../../hooks/useHistoryCustom'
import useSettingsV2 from '../../hooks/useSettingsV2'

function Contacts() {
  const history = useHistoryCustom()
  const { myContext, event, userId } = useMyContext()
  const { settings } = useSettingsV2()
  const screens = Grid.useBreakpoint()
  // `md` passe à true dès ~768px : en dessous on est sur tel → affichage liste plutôt que tableau.
  const isMobile = !screens.md

  const { data: contacts } = useGetMyContactsQuery({ ...myContext })
  const [createExport] = useLazyGetMyContactsQuery()
  const [createLink, { isLoading: saving }] = useCreateUserLinkMutation()

  const display = value => (value === '' || value === null || value === undefined ? '—' : value)
  // Données affichées = les champs choisis dans la conf FO v2 (FO_MEETING_CONTACT_DISPLAY_FIELDS),
  // résolus côté serveur dans `contact.fiche` = [{ key, label, value }] (mêmes données que la fiche/export).
  // Tous les contacts partagent la même config → on prend le 1er qui a une fiche comme gabarit de colonnes.
  const ficheTemplate = ((contacts || []).find(c => c.fiche && c.fiche.length) || {}).fiche || []

  // Ré-ouverture d'un contact : revoir ses données (fiche) + modifier le commentaire.
  const [selected, setSelected] = useState(null)
  const [comment, setComment] = useState('')

  const openContact = record => {
    setSelected(record)
    setComment(record.comment || '')
  }

  const saveComment = async () => {
    await createLink({ ...myContext, userIdA: userId, userIdB: selected.id, body: { comment } }).unwrap()
    message.success('Commentaire mis à jour')
    setSelected(null)
  }

  // const createExport = () => {
  //   try {
  //     const models = form.pages.reduce(
  //       (prev, curr) => [...prev, ...curr.models.filter(m => ['authentication', 'user'].includes(m.entity))],
  //       []
  //     )

  //     const format = user =>
  //       models.reduce((prev, curr) => {
  //         if (curr.fieldExtended) {
  //           const userValues = user.extended[curr.fieldExtended]
  //           if (!curr.values || !userValues) return { ...prev, [curr.label]: userValues }

  //           const array = Object.entries(userValues)
  //             .filter(([, v]) => v)
  //             .map(([k]) => {
  //               const find = curr.values.find(f => f.field === k)
  //               if (find) return find.label
  //               return null
  //             })

  //           return { ...prev, [curr.label]: array.join(', ') }
  //         }
  //         if (curr.entity === 'user') return { ...prev, [curr.label]: user[curr.field] }
  //         if (curr.entity === 'authentication')
  //           return { ...prev, [curr.label]: user.authentication ? user.authentication[curr.field] : null }
  //         return null
  //       }, {})

  //     json2excel({
  //       data: contacts.map(contact => ({
  //         Date: new Date(contact.linkedAt).toLocaleString(),
  //         ...format(contact),
  //         Commentaire: contact.comment,
  //       })),
  //     })
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  return (
    <div>
      <Button type="primary" onClick={() => history.push('')} style={{ marginBottom: 10 }}>
        Retour
      </Button>
      <Card
        title={`Vos contacts (${(contacts || []).length})`}
        bordered={!isMobile}
        bodyStyle={{ padding: isMobile ? 0 : 24 }}
        extra={
          <Button
            type="primary"
            onClick={async () => {
              const url = await createExport({
                ...myContext,
                createExport: true,
              }).unwrap()
              const response = await fetch(url, { cache: 'no-cache' })
              fileDownload(
                await response.blob(),
                `export-users-${event.alias}-${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}.xlsx`
              )
            }}
            disabled={!(contacts || []).length}
          >
            {settings?.FO_MEETING_CONTACT_EXPORT_LABEL || 'Exporter'}
          </Button>
        }
      >
        {isMobile ? (
          // Sur tel : liste pleine largeur (pas de scroll horizontal ni de bordures de card qui rognent l'espace).
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {!(contacts || []).length && (
              <div style={{ padding: 24, textAlign: 'center', color: '#8c8c8c' }}>Aucun contact</div>
            )}
            {(contacts || []).map(record => {
              const name = `${record.firstName || ''} ${record.lastName || ''}`.trim() || 'Contact'
              return (
                <div
                  key={record.id}
                  style={{
                    padding: '10px 12px',
                    borderBottom: '1px solid #f0f0f0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                    <strong style={{ fontSize: 16, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {name}
                    </strong>
                    <Button type="primary" size="small" style={{ flexShrink: 0 }} onClick={() => openContact(record)}>
                      Modifier
                    </Button>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 2, fontSize: 13, color: '#595959' }}>
                    {(record.fiche || [])
                      .filter(f => f.value !== '' && f.value !== null && f.value !== undefined)
                      .map(f => (
                        <div key={f.key} style={{ display: 'flex', gap: 6, flexWrap: 'wrap', wordBreak: 'break-word' }}>
                          <span style={{ color: '#8c8c8c' }}>{f.label} :</span>
                          <span>{f.value}</span>
                        </div>
                      ))}
                    {record.comment && (
                      <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        <span style={{ color: '#8c8c8c' }}>Commentaire :</span> {record.comment}
                      </div>
                    )}
                    <span style={{ color: '#8c8c8c' }}>{new Date(record.linkedAt).toLocaleString()}</span>
                  </div>
                </div>
              )
            })}
          </div>
        ) : (
          <Table
            scroll={{ x: true }}
            dataSource={contacts}
            rowKey="id"
            columns={[
              {
                title: '',
                key: 'actions',
                render: (_, record) => (
                  <Button type="primary" onClick={() => openContact(record)}>
                    Modifier
                  </Button>
                ),
              },
              { title: 'Date', dataIndex: 'linkedAt', render: date => new Date(date).toLocaleString() },
              // Une colonne par champ configuré dans la conf FO v2 (résolu dans record.fiche).
              ...ficheTemplate.map(f => ({
                title: f.label,
                key: f.key,
                render: (_, r) => {
                  const found = (r.fiche || []).find(x => x.key === f.key)
                  return display(found ? found.value : '')
                },
              })),
              {
                title: 'Commentaire',
                dataIndex: 'comment',
                width: 240,
                render: v => (
                  <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{display(v)}</div>
                ),
              },
            ]}
          />
        )}
      </Card>

      <Modal
        title={selected ? `${selected.firstName || ''} ${selected.lastName || ''}`.trim() || 'Contact' : ''}
        open={!!selected}
        onCancel={() => setSelected(null)}
        footer={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={() => setSelected(null)}>Fermer</Button>
            <Button type="primary" onClick={saveComment} loading={saving}>
              Enregistrer
            </Button>
          </div>
        }
      >
        {selected && (
          <div>
            {/* Revoir les données de la personne (même fiche que le scan). */}
            <ContactDisplay fiche={selected.fiche} />
            {/* Modifier le commentaire. */}
            <div style={{ padding: '0 16px' }}>
              <strong>Commentaire</strong>
              <Input.TextArea value={comment} onChange={e => setComment(e.target.value)} rows={4} style={{ marginTop: 6 }} />
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default Contacts
